import { HOST } from '../helpers';

export const ACQUISITIONTESTS = 'AcquisitionTests';
export const ARTIFACTPERFORMANCE = 'ArtifactPerformance';
export const ARTIFACTREGRESSION = 'ArtifactRegression';
export const AXIOMUITESTS = 'AxiomUITests';
export const CASEAMENDINGTESTS = 'CaseAmendingTests';
export const CASEMERGINGTESTS = 'CaseMergingTests';
export const CASEMETRICS = 'CaseMetrics';
export const CLOUDTESTS = 'CloudTests';
export const DIFFTOOLREGRESSION = 'DifftoolRegression';
export const ENGINEMETRICS = 'EngineMetrics';
export const EXPORTTESTS = 'ExportTests';
export const JOBBENCHMARK = 'JobBenchmark';
export const REMOTEACQUIREREGRESSION = 'RemoteAcquireRegression';
export const IMAGESEARCH = 'ImageSearch';
export const INSTALLERTESTS = 'UIInstallerTests';
export const PERFORMANCETESTS = 'PerformanceTests';
export const TESTSTUDIO = 'TestStudio';
export const UITESTS = 'UITests';
export const UNKOWNLEGACY = 'UnknownLegacy';

export const DISPATCHER_TYPES = [
  ACQUISITIONTESTS,
  ARTIFACTPERFORMANCE,
  ARTIFACTREGRESSION,
  AXIOMUITESTS,
  CASEAMENDINGTESTS,
  CASEMERGINGTESTS,
  CASEMETRICS,
  CLOUDTESTS,
  DIFFTOOLREGRESSION,
  EXPORTTESTS,
  REMOTEACQUIREREGRESSION,
  IMAGESEARCH,
  INSTALLERTESTS,
  JOBBENCHMARK,
  PERFORMANCETESTS,
  TESTSTUDIO,
  UITESTS,
  UNKOWNLEGACY
];

export const getDispatcherPageLink = (dispatcherType, dispatcherNumber, dispatcherName) =>
{
  switch (dispatcherType) {
    case ACQUISITIONTESTS:
      return `${HOST}/acquisition?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_acquisition_metrics';
    case ARTIFACTREGRESSION:
      return `${HOST}/artifact-regression?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_artifact_regression';
    case AXIOMUITESTS:
      return `${HOST}/axiom-ui?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_axiom_ui_tests';
    case CASEAMENDINGTESTS:
      return `${HOST}/case-amending?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_case_amending';
    case CASEMERGINGTESTS:
      return `${HOST}/case-merging?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_case_merging';
    case CASEMETRICS:
      if (dispatcherName.includes('engine'))
      {
        return `${HOST}/engine-metrics`;
      }
      return `${HOST}/case-metrics`;
    case CLOUDTESTS:
      return `${HOST}/cloud`;
    case DIFFTOOLREGRESSION:
      return `${HOST}/diff?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_difftool_regression';
    case EXPORTTESTS:
      return `${HOST}/export-regression?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_export_tests';
    case REMOTEACQUIREREGRESSION:
      return `${HOST}/remote-acquire-regression?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_remote_acquire_e2e_cli';
    case INSTALLERTESTS:
      return `${HOST}/installer?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_ui_installer_tests';
    case PERFORMANCETESTS:
      return `${HOST}/performance-metrics`;
    case TESTSTUDIO:
      return `${HOST}/test-studio?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_teststudio';
    case UITESTS:
      return `${HOST}/white?nb=${dispatcherNumber}` +
      '&nm=common_dispatcher_ui_tests';
    default:
      return '';
  }
};


// WEBPACK FOOTER //
// src/helpers/dispatcherTypes.js